import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ChevronRight } from 'lucide-react';
const modules = ['Evaluación express, diagnóstico y organización inicial', 'Planificación terapéutica y protocolos de intervención', 'Banco premium de actividades y sesiones listas para usar', 'Seguimiento, evolución y control profesional del paciente', 'Informes, gestión y organización total del consultorio'];
export function ProfessionalSystem() {
  return <section className="py-10 bg-transparent relative" data-id="element-172">
      <div className="container mx-auto px-6 max-w-3xl relative z-10" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative rounded-3xl bg-gradient-to-b from-[#150a1f] to-[#0c0613] border border-fuchsia-400/40 shadow-[0_0_80px_rgba(217,70,239,0.35)] overflow-hidden" data-id="element-174">
          {/* Top hairline highlight */}
          <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-fuchsia-400/70 to-transparent" data-id="element-175" />
          {/* Bottom hairline highlight */}
          <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-violet-400/40 to-transparent" data-id="element-176" />

          <div className="relative p-7 md:p-10" data-id="element-177">
            {/* PLAN PRO badge */}
            <motion.div initial={{
            opacity: 0,
            y: 8
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-fuchsia-500/15 border border-fuchsia-400/50 text-fuchsia-200 text-[11px] font-bold tracking-[0.18em] uppercase mb-6 shadow-[0_0_20px_rgba(217,70,239,0.35)]" data-id="element-178">
              Plan Pro FonoClinic OS
            </motion.div>

            {/* Headline */}
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white leading-tight mb-4" data-id="element-179">
              Intervención y{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-fuchsia-300 via-purple-400 to-violet-300 drop-shadow-[0_0_25px_rgba(217,70,239,0.5)]" data-id="element-180">
                Gestión Profesional
              </span>
            </h2>

            {/* Body copy */}
            <p className="text-[15px] md:text-base text-gray-300 leading-relaxed mb-8 max-w-xl" data-id="element-181">
              Pasá de tener materiales sueltos a contar con un sistema completo
              de trabajo profesional. Incluye{' '}
              <span className="text-white font-semibold" data-id="element-182">
                5 módulos premium
              </span>
              :
            </p>

            {/* Modules list */}
            <ul className="space-y-3" data-id="element-183">
              {modules.map((mod, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -12
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1 + i * 0.08,
              duration: 0.5
            }} className="group flex items-center gap-4 py-2 transition-all" data-id="element-184">
                  {/* Numbered circle (no blur halo) */}
                  <div className="shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-fuchsia-500/40 to-violet-600/40 border border-fuchsia-300/60 flex items-center justify-center text-fuchsia-100 font-bold text-sm tracking-wide" data-id="element-185">
                    0{i + 1}
                  </div>

                  {/* Module text */}
                  <p className="flex-1 text-sm md:text-[15px] text-gray-100 font-medium leading-snug" data-id="element-186">
                    {mod}
                  </p>

                  {/* Chevron */}
                  <ChevronRight className="w-4 h-4 text-fuchsia-400/50 group-hover:text-fuchsia-300 group-hover:translate-x-0.5 transition-all shrink-0" data-id="element-187" />
                </motion.li>)}
            </ul>

            {/* Footer decorative element */}
            <div className="mt-8 flex items-center justify-center gap-2" data-id="element-188">
              <div className="h-px w-12 bg-gradient-to-r from-transparent to-fuchsia-400/60" data-id="element-189" />
              <Sparkles className="w-4 h-4 text-fuchsia-400" data-id="element-190" />
              <div className="h-px w-12 bg-gradient-to-l from-transparent to-fuchsia-400/60" data-id="element-191" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}